import { useEffect, useState } from "react";

const NAV = [
  { href: "#today", label: "今日最新" },
  { href: "#breaking", label: "刚刚爆" },
  { href: "#topics", label: "话题热榜" },
  { href: "#feature", label: "深度专题" },
  { href: "#about", label: "关于我们" },
  { href: "#faq", label: "常见问题" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const kw = keyword.trim();
    if (!kw) return;
    const target = document.querySelector("#topics");
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md border-b border-background-200/80 shadow-[0_1px_0_0_rgba(0,0,0,0.02)]"
          : "bg-background-50/40 border-b border-transparent"
      }`}
    >
      {/* top ribbon */}
      <div className="bg-primary-600 text-background-50">
        <div className="container-x flex h-8 items-center justify-between text-xs">
          <p className="flex items-center gap-2 whitespace-nowrap">
            <span className="inline-flex h-1.5 w-1.5 animate-pulse rounded-full bg-accent-400" />
            <span className="hidden sm:inline">本日已更新</span>
            <span className="font-semibold">12 条新瓜 · 3 条刚刚爆</span>
          </p>
          <p className="hidden items-center gap-2 text-background-50/85 md:flex">
            <i className="ri-calendar-2-line text-[13px]" />
            <span className="whitespace-nowrap">2026 年 9 月 9 日 周三</span>
            <span className="mx-2 opacity-40">|</span>
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-hotspot-line text-[13px] text-accent-300" />
              今日瓜力爆棚
            </span>
          </p>
        </div>
      </div>

      {/* main bar */}
      <div className="container-x flex items-center justify-between gap-4 py-3.5 md:py-4">
        <a href="#top" className="group flex items-center gap-2.5" aria-label="每日瓜料 首页">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-flashlight-fill text-xl" />
          </span>
          <span className="leading-none">
            <h1 className="font-heading text-xl font-black tracking-tight text-foreground-950 md:text-2xl">
              每日瓜料
            </h1>
            <span className="mt-1 block text-[11px] font-medium tracking-wider text-foreground-500">
              TODAY&apos;S GOSSIP · 今日瓜 · 今日爆
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="whitespace-nowrap rounded-full px-3.5 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2.5">
          <form
            onSubmit={submitSearch}
            className="hidden items-center gap-2 rounded-full border border-background-200 bg-background-100/70 px-3.5 py-2 md:flex"
          >
            <i className="ri-search-line text-[15px] text-foreground-500" />
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索明星 / 话题"
              aria-label="站内搜索"
              className="w-28 bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400 lg:w-36"
            />
          </form>
          <a
            href="#join"
            className="hidden whitespace-nowrap rounded-full bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex items-center"
          >
            订阅每日瓜料
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="展开导航菜单"
            aria-expanded={open}
            className="flex h-10 w-10 items-center justify-center rounded-lg border border-background-200 bg-background-50 text-foreground-800 transition-colors hover:bg-background-100 lg:hidden"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`} />
          </button>
        </div>
      </div>

      {/* mobile nav panel */}
      {open ? (
        <nav className="border-t border-background-200 bg-background-50 lg:hidden" aria-label="移动端导航">
          <div className="container-x grid grid-cols-2 gap-1.5 py-4">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="flex items-center gap-2 rounded-lg bg-background-100/80 px-3.5 py-2.5 text-sm font-medium text-foreground-800"
              >
                <i className="ri-arrow-right-s-line text-primary-500" />
                {n.label}
              </a>
            ))}
          </div>
        </nav>
      ) : null}
    </header>
  );
}